/*==============================================================================
  ___  _   _    _
 /   || | | |  | |
 \__  | | | |  | |  __
 /    |/  |/_) |/  /  \_/\/
 \___/|__/| \_/|__/\__/  /\_/
               |\
               |/
  Concrete v0.1
  https://elkfox.com
  https://experts.shopify.com/elkfox
  Copyright 2015 Shopify Inc. & Elkfox Co Pty Ltd
==============================================================================*/

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e, r, a) { var n = new RegExp("(" + r + "=).*?(&|$)"), c = e; return c = e.search(n) >= 0 ? e.replace(n, "$1" + a + "$2") : c + (c.indexOf("?") > 0 ? "&" : "?") + r + "=" + a };

var $ = jQuery;

// Money formatting
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function (cents, format) {

    var value = '',
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = (format || "${{amount}}");
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}
// Functions
window.concrete = window.concrete || {};
concrete.cacheSelectors = function () {
  concrete.cache = {
    // General
    $html: $('html'),
    $document: $(document),
    $body: $(document.body),
    // Visibility
    $toggleItemLink: $('.js_toggle'),
    $revealItemLink: $('.js_open'),
    $hideItemLink: $('.js_close'),
    // Collection Pages
    $changeView: $('.change-view'),
    // Products
    $productMainImage: $('#ProductMainImage'),
    $productThumbnailImages: $('#ProductThumbnailImages').find('a.thumbnail'),
    // Ajax Forms
    $ajaxForm: $('.ajaxForm form'),
    // Quick Look
    $quickLookButton: $('.quickLookButton'),
    // TO DO
    // Move variables from "Variant Switching" function

  };
};

// Initialize the functions
concrete.init = function () {
  concrete.cacheSelectors()
  concrete.visibilityManager()
  concrete.responsiveVideos()
  concrete.collectionViews()
  concrete.productImageSwitch()
  concrete.quickLook()
  concrete.ajaxCustomerForms()
  concrete.ajaxSearchForms()
  concrete.touchEvents()
};

// Get current window location
concrete.getHash = function () {
  return window.location.hash;
};

// responsive Videos
concrete.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });
  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on back" bug https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

// Collection view switching
concrete.collectionViews = function () {
  if (concrete.cache.$changeView.length) {
    concrete.cache.$changeView.on('click', function () {
      var view = $(this).data('view'),
        url = document.URL,
        hasParams = url.indexOf('?') > -1;
      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

// Visibility Management
concrete.visibilityManager = function () {
  // Reveal elements on toggle
  concrete.cache.$toggleItemLink.on('click', function (event) {
    event.preventDefault();
    var itemId = $(this).attr('href');
    $(itemId).toggleClass('hidden');
  });
  // display elements on click
  concrete.cache.$revealItemLink.on('click', function (event) {
    event.preventDefault();
    var itemId = $(this).attr('href');
    $(itemId).removeClass('hidden');
  });
  // hide elements on click
  concrete.cache.$hideItemLink.on('click', function (event) {
    event.preventDefault();
    var itemId = $(this).attr('href');
    $(itemId).addClass('hidden');
  });
};

// Product Image Thumbnails
concrete.productImageSwitch = function () {
  if (concrete.cache.$productThumbnailImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    concrete.cache.$productThumbnailImages.on('click', function (event) {
      event.preventDefault();
      var newImage = $(this).attr('href');
      concrete.switchImage(newImage, null, concrete.cache.$productMainImage);
    });
  }
};

concrete.productSlick = function (parent, child, object) {
  var productObject = $(parent).closest('[data-section-type="product"]');
  if (object) {
    productObject = $(object);
  }
  $(parent).slick({
    autoplay: $(productObject).data('autoplay'),
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0 // Start at first image
  })
  if ($(productObject).data('thumbnails')) {
    $(child).slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      asNavFor: parent,
      swipeToSlide: false,
      arrows: true,
      prevArrow: $(productObject).data('arrow-prev'),
      nextArrow: $(productObject).data('arrow-next'),
      dots: false,
      centerMode: false,
      focusOnSelect: false,
      initialSlide: 0 // Start at first image
    })
  }
}

concrete.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

// Variant Switching
concrete.switchVariant = function (options) {
  var moneyFormat = options.moneyFormat,
    variant = options.variant,
    $addToCart = options.addToCart || $("#AddToCart"),
    $addToCartText = options.addToCartText || $("#AddToCartText"),
    $productPrice = options.productPrice || $("#ProductPrice"),
    $productNote = options.productNote || $("#Note"),
    $comparePrice = options.comparePrice || $("#ComparePrice"),
    $variantUrl = options.variantUrl || null,
    $onSale = options.onSale || $("#OnSale"),
    slick = options.slick || false,
    $slickWrapper = options.slickWrapper || $('.slick-initialized')

  // change to the variants featured image if you're using slick carousel and popups.
  if (variant) {
    if (variant.featured_image && slick == true) {
      $slickWrapper.slick('slickGoTo', (variant.featured_image.position - 1))
    }
  }
};

// Quick Look
concrete.quickLook = function () {
  $(document).on('concrete:popup:close', function () {
    setTimeout(function () { $('.popup .slick-initialized').slick('unslick') }, 250)
});

concrete.cache.$quickLookButton.on('click', function (event) {
  var productSelector = $(this).data("product")
  var quicklookObject = $(this)
  var product = $('pre[data-product="' + productSelector + '"]').first().text()
  product = jQuery.parseJSON(product)
  var popupElement = $("#PopupQuicklook")

  $(popupElement).find('[data-product-attribute]').each(function () {
    var productAttribute = $(this).data('product-attribute')
    if (productAttribute == 'product-image') {
      $(this).html('<img src="' + product[productAttribute] + '">');
    }
    else if (productAttribute == 'images') {
      var productImages = product[productAttribute];
      var productSlideshow = popupElement.find('.product-slideshow')
      var navSlideshow = popupElement.find('.product-nav-slideshow')
      productSlideshow.empty();
      navSlideshow.empty();

      if (productImages.length > 1) {
        $.each(productImages, function (key, image) {
          image.replace('.jpg, ', '_x500.jpg')
          image.replace('.png, ', '_x500.png')
          productSlideshow.append('<img src="' + image + '" data-thumb="' + image + '">')
          navSlideshow.append('<img src="' + image + '" data-thumb="' + image + '">')
        })
        concrete.productSlick('#PopupQuicklook .product-slideshow', '#PopupQuicklook .product-nav-slideshow', quicklookObject)
      }
      else {
        productSlideshow.append('<img src="' + productImages[0] + '" data-thumb="' + productImages[0] + '">')
      }
    }
    else if (productAttribute == 'variants') {

      var variants = product[productAttribute];
      var variantElement = ''
      var variantContainer = popupElement.find('.product-variants')
      variantContainer.empty();

      // is there more than one variant?
      if (variants.length > 1) {

        var variantOption = '';
        // create a dropdown of variants
        $.each(variants, function (key, variant) {
          variantOption += '<option value="' + escape(variant["option1"]) + '">' + variant.title + '</option>';
        })

        variantElement = '<select id="quicklookSelect" data-index="option1">' + variantOption + '</select>'

        // Switch variants
        var selectCallback = function (evt) {
          concrete.switchVariant({
            moneyFormat: "",
            variant: evt.variant,
            slick: true,
            slickWrapper: $('#PopupQuicklook .product-slideshow')
          })
        }
      }
      if (variants[0].available) {
        variantElement += '<button class="popup-cancel" type="submit" name="add" data-quick-add="' + variants[0].id + '"><span id="AddToCartText">Add to Cart</span></button>'
      } else {
        variantElement += '<button class="popup-cancel" type="submit" name="add" data-quick-add="' + variants[0].id + '" disabled="disabled"><span id="AddToCartText">Sold Out</span></button>'
      }

      variantContainer.append(variantElement)
      options = {
        $container: $('#PopupQuicklook'),
        enableHistoryState: false,
        singleOptionSelector: '#quicklookSelect',
        product: product
      }
      var variantSwitcher = new concrete.Variants(options)

      $('#PopupQuicklook').on('variantChange', function (event) {
        selectCallback(event);
        $('#PopupQuicklook [data-quick-add]').data('quick-add', event.variant.id);
        if (event.variant.available) {
          $('#PopupQuicklook [data-quick-add]').html('<span id="AddToCartText">Add to Cart</span>').prop("disabled", false);
        } else {
          $('#PopupQuicklook [data-quick-add]').html('<span id="AddToCartText">Sold Out</span>').prop("disabled", true);
        }
      });

    } else if (productAttribute == 'title') {
      $(this).html('<a id="VariantUrl" href="products/' + product.handle + '">' + product[productAttribute] + '</a>');
    } else if (productAttribute == 'description') {
      var description = product[productAttribute]
      var truncate_amount = 25 // edit this to change truncate amount
      var words = description.split(" ")
      var numberOfWords = words.length

      if (numberOfWords > truncate_amount) {
        description = words.splice(0, truncate_amount).join(" ") // truncated to 25 words
        description = description + '...'
      }
      $(this).html(description);
    } else if (productAttribute == 'price') {
      var money = Shopify.formatMoney(product[productAttribute]);
      $(this).html(money);
    }
    else {
      $(this).html(product[productAttribute]);
    }
  });
});
}

// Ajax Forms

// Contact and Customer
concrete.ajaxCustomerForms = function () {
  var challenge = false;
  if (concrete.cache.$ajaxForm.length) {
    concrete.cache.$ajaxForm.submit(function (e) {
      if (challenge === false) {
        e.preventDefault()
        var genericError = '<div class="errors">An error occured. Please try again.</div>'
        var formId = $(this).attr('id')
        $.ajax({
          type: $(this).attr('method'),
          url: $(this).attr('action'),
          data: $(this).serialize(),
          cache: false,
          context: this,
          beforeSend: function () {
            $(this).children().prop('disabled', true)
          },
          error: function (response) {
            $(this).children().prop('disabled', false)
            if (response.status == 429) {
              // submit the form if we need to get the captcha
              challenge = true;
              concrete.cache.$ajaxForm.submit();
              //window.location.replace( window.location.origin +'/challenge#'+ formId )
            } else {
              $(this).before("<div class='errors'>" + response.statusText + "</div>");
            }
          },
          success: function (response) {
            if (formId == 'customer_login') {
              var accountContainer = '#PopupAccount .popup-content'
              var account = $(response).find(accountContainer);
              account = $(account).html()
              $(accountContainer).html(account).hide().fadeIn('fast')
              $('[data-target="#PopupAccount"]').text('Account');
            } else {
              // Not a login form
              var successFilteredData = $(response).find('.form-success').hide().fadeIn('fast')
              var errorFilteredData = $(response).find('.errors').hide().fadeIn('fast')
              if ($(successFilteredData).length) {
                $(this).before(successFilteredData)
                $(this).fadeOut('fast')
              } else if ($(errorFilteredData).length) {
                $(this).before(errorFilteredData)
              } else {
                $(this).before(genericError)
              }
            }
          }
        })
      }
    })
  }
}
// Search
concrete.ajaxSearchForms = function () {
  var currentAjaxRequest = null;
  var searchForm = $('.ajaxSearch form[action="/search"]').css('position', 'relative').each(function () {
    var input = $(this).find('input[name="q"]'),
      offSet = input.position().top + input.innerHeight()
    $('<ul class="search-results"></ul>').css({ 'position': 'absolute', 'top': offSet }).appendTo($(this))
    input.attr('autocomplete', 'off').bind('keyup change', function () {
      // On Keychange grab all the required data
      var term = $(this).val(),
        form = $(this).closest('form'),
        searchURL = '/search?type=product&q=' + term,
        resultsList = form.find('.search-results')
      if (term.length > 3 && term != $(this).attr('data-old-term')) {
        $(this).attr('data-old-term', term) // Saving old query.
        if (currentAjaxRequest != null) currentAjaxRequest.abort()
        // get the data from the search.json.template
        currentAjaxRequest = $.get(searchURL + '&view=json', function (data) {
          // parse the data so it can be used
          var data = JSON.parse(data)
          resultsList.empty();
          if (data.results_count == 0) {
            resultsList.html('<li class="row collapse table"><span class="column l12 v-middle left">No results found!</span></li>')
            resultsList.addClass('active');
            // resultsList.hide();
          } else {
            // If we have results.
            $.each(data.results, function (index, item) {
              var link = $('<a></a>').attr('href', item.url)
              link.append('<span class="column l2 v-middle"><img src="' + item.thumbnail + '" /></span>')
              link.append('<span class="column l10 v-middle left">' + item.title + '</span>')
              link.wrap('<li class="row collapse table result"></li>')
              resultsList.append(link.parent())
            })
            // The Ajax request will return at the most 10 results.
            // If there are more than 10, let's link to the search results page.
            if (data.results_count > 10) {
              resultsList.append('<li class="row collapse table"><span class="column l12 v-middle left"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>')
            }
            resultsList.addClass('active');
          }
        })
      }
    })

    // Clicking outside makes the results disappear.
    $('body').bind('click', function () {
      $('.search-results').removeClass('active')
    })

  })
}



// Touch events
concrete.touchEvents = function () {
  if (Modernizr.touchevents) {
    // console.log('touch is active')
  } else {
    // console.log('touch is not active')
  }
}

// Initialize on docready
$(concrete.init);
